export default __webpack_public_path__ + "static/media/project2.001f2ea8.png";